// src/components/ui/Spinner.jsx
import React from "react";

const Spinner = () => (
  <div className="text-center py-6">
    <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mx-auto" />
    <div className="text-sm text-gray-500 mt-2">Đang tải...</div>
  </div>
);

export default Spinner;
